import React from 'react';
import {injectIntl} from "react-intl";

function JobTitleAutoSuggestField() {
  return '';
}

export default injectIntl(JobTitleAutoSuggestField);
